const get_resource_uri = (uri) => {
	const script = document.createElement("script");
	
	let cacheIndex = window.GEOLINQ_CACHE_INDEX || {};
	
	let cacheBuster = cacheIndex[uri];
	if( !cacheBuster ) {
		cacheBuster = `x${new Date().getTime()}`;
	}
	
	return `${uri}?${cacheBuster}`;	
}

export {
	get_resource_uri
}